import Auth from '../api/auth';
import { usePlanLimits } from 'dashboard/composables/usePlanLimits';

// Plan-related errors are handled globally so any endpoint returning
// `error_code: LIMIT_EXCEEDED` triggers the upgrade modal automatically.
const handlePlanLimitError = error => {
  const data = error?.response?.data;
  if (data?.error_code !== 'LIMIT_EXCEEDED') return;

  const { handleApiError } = usePlanLimits();
  handleApiError(error);

  // Replace the default axios message ("Request failed with status code 403")
  // with the user-friendly message coming from the API so any downstream
  // toast/alert displays useful context instead of HTTP gibberish.
  if (data.message) {
    error.message = data.message;
  }
};

const parseErrorCode = error => {
  handlePlanLimitError(error);
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
